require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es6/parse-float.js
// module id = ./node_modules/core-js/es6/parse-float.js
// module chunks = polyfills